// extracted by mini-css-extract-plugin
module.exports = {"header__container":"OurBrainHeader_header__container__3FXLt","ourBrainTItleContainer":"OurBrainHeader_ourBrainTItleContainer__t_2pO"};